import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { eldAvailabilityStatusSchema } from '../schemas/eld-availability-status.schema';

/**
 * Gets the company Sync Availability Status
 * @returns Data object indicating Sync Availability Status
 */
export function getCompanySyncAvailabilityStatus(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment.resolve(this).companySyncAvailabilityStatusUrl,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(eldAvailabilityStatusSchema));
}
